// FAQ Search Standalone Code - Pure Vanilla JavaScript (No Dependencies)
(function() {
  
  // Utility functions
  var utils = {
    getTemplate: function(template) {
      var templateElement = document.querySelector('[data-template-for="' + template + '"]');
      return templateElement ? templateElement.innerHTML : null;
    },
    
    createElementFromHTML: function(htmlString) {
      var div = document.createElement('div');
      div.innerHTML = htmlString.trim();
      return div.firstChild;
    },

    // Simple search function that searches through question and answer text
    searchFAQ: function(faqData, searchTerm) {
      if (!searchTerm || searchTerm.trim() === '') {
        return faqData;
      }

      var term = searchTerm.toLowerCase().trim();
      var results = [];

      for (var i = 0; i < faqData.length; i++) {
        var item = faqData[i];
        var question = (item.question || '').toLowerCase();
        var answer = (item.answer || '').toLowerCase();
        var category = (item.category || '').toLowerCase();

        // Check if search term appears in question, answer, or category
        if (question.includes(term) || answer.includes(term) || category.includes(term)) {
          results.push(item);
        }
      }

      return results;
    },

    // Advanced search with word matching and scoring
    advancedSearchFAQ: function(faqData, searchTerm) {
      if (!searchTerm || searchTerm.trim() === '') {
        return faqData;
      }

      var term = searchTerm.toLowerCase().trim();
      var searchWords = term.split(/\s+/); // Split into individual words
      var results = [];

      for (var i = 0; i < faqData.length; i++) {
        var item = faqData[i];
        var question = (item.question || '').toLowerCase();
        var answer = (item.answer || '').toLowerCase();
        var category = (item.category || '').toLowerCase();
        
        var score = 0;
        var matchFound = false;

        // Check each search word
        for (var j = 0; j < searchWords.length; j++) {
          var word = searchWords[j];
          
          // Higher score for exact matches in question
          if (question.includes(word)) {
            score += 10;
            matchFound = true;
            
            // Bonus for exact word match
            if (question.indexOf(word) === 0) {
              score += 5;
            }
          }
          
          // Medium score for matches in answer
          if (answer.includes(word)) {
            score += 5;
            matchFound = true;
          }
          
          // Lower score for category matches
          if (category.includes(word)) {
            score += 2;
            matchFound = true;
          }
        }

        if (matchFound) {
          item._searchScore = score;
          results.push(item);
        }
      }

      // Sort by score (highest first)
      results.sort(function(a, b) {
        return (b._searchScore || 0) - (a._searchScore || 0);
      });

      return results;
    }
  };

  // FAQ Search Functionality
  function FaqSearch() {
    var selectors = {
      container: '.faq-search-input-wrapper',
      searchInput: '#faq-search',
      searchContainer: '.faq-search-wrapper',
      answersContainer: '.faq-container',
      searchButton: '.search-button',
      searchClose: '.search-button.close',
    };

    var searchOptions = {
      useAdvancedSearch: true, // Set to false for simple search
      minSearchLength: 1, // Minimum characters before searching
      debounceDelay: 300 // Delay in milliseconds for search input
    };

    function initSearch() {
      // FAQ data should be available in window.faq
      var list = window.faq;
      
      if (!list) {
        console.warn('FAQ data not found. Please ensure window.faq is defined.');
        return;
      }

      // Get DOM elements
      var searchInput = document.querySelector(selectors.searchInput);
      var searchContainer = document.querySelector(selectors.searchContainer);
      var answersContainer = document.querySelector(selectors.answersContainer);
      var searchButton = document.querySelector(selectors.searchButton);

      if (!searchInput || !searchContainer) {
        console.warn('Required FAQ search elements not found.');
        return;
      }

      var searchTimeout;

      // Search on input with debouncing
      searchInput.addEventListener('input', function() {
        var search_value = this.value.trim();

        // Clear previous timeout
        if (searchTimeout) {
          clearTimeout(searchTimeout);
        }

        // Debounce the search
        searchTimeout = setTimeout(function() {
          if (search_value.length >= searchOptions.minSearchLength) {
            search(search_value);
          } else if (search_value === '') {
            closeSearch();
          }
        }, searchOptions.debounceDelay);
      });

      // Optional: Search on button click
      if (searchButton) {
        searchButton.addEventListener('click', function() {
          var search_value = searchInput.value.trim();
          if (search_value.length >= searchOptions.minSearchLength) {
            search(search_value);
          }
        });
      }

      // Close search when clicking on close button
      document.addEventListener('click', function(e) {
        if (e.target.closest(selectors.searchClose)) {
          closeSearch();
        }
      });

      // Optional: Clear search on escape key
      searchInput.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          closeSearch();
        }
      });

      function closeSearch() {
        searchContainer.innerHTML = '';
        searchContainer.classList.remove('active'); // Remove active class
        if (answersContainer) {
          answersContainer.classList.remove('hidden'); // Show original FAQ content
        }
        if (searchButton) {
          searchButton.classList.remove('close'); // Remove close class from button
        }
        searchInput.value = '';
      }

      function openSearch() {
        searchContainer.classList.add('active'); // Add active class
        if (answersContainer) {
          answersContainer.classList.add('hidden'); // Hide original FAQ content
        }
        if (searchButton) {
          searchButton.classList.add('close'); // Add close class to button
        }
      }

      function search(search_value) {
        var result;
        
        // Choose search method
        if (searchOptions.useAdvancedSearch) {
          result = utils.advancedSearchFAQ(list, search_value);
        } else {
          result = utils.searchFAQ(list, search_value);
        }
        
        // Clear previous results
        searchContainer.innerHTML = '';
        
        if (result.length === 0) {
          searchContainer.innerHTML = '<p class="no-results">No results found for "' + search_value + '"</p>';
          searchContainer.classList.remove('active'); // Remove active class for no results
          if (answersContainer) {
            answersContainer.classList.remove('hidden'); // Show original FAQ content
          }
          if (searchButton) {
            searchButton.classList.remove('close'); // Remove close class from button
          }
          return;
        }
        
        // Open search (add active class and close class to button)
        openSearch();
        
        // Create results
        for (var i = 0; i < result.length; i++) {
          var faqItem = createFaqItem(result[i]);
          searchContainer.appendChild(faqItem);
        }
      }

      function createFaqItem(faqData) {
        // Create the accordion structure matching your HTML (without col wrapper)
        var faqItemHTML = 
          '<accordion-custom class="accordion-custom__metafield custom-behaviour-2">' +
            '<details class="details faq-item">' +
              '<summary class="details__header faq-item__title">' +
                faqData.question +
                '<span class="svg-wrapper icon-plus">' +
                  '<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<path class="vertical" d="M2.75 7H11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
                    '<path class="horizontal" d="M7 2.75L7 11.25" stroke="currentColor" stroke-width="var(--icon-stroke-width)" stroke-linecap="round"/>' +
                  '</svg>' +
                '</span>' +
              '</summary>' +
              '<div class="details-content faq-item__content">' +
                '<div class="faq-content faq-item__answer rte">' +
                  faqData.answer +
                '</div>' +
              '</div>' +
            '</details>' +
          '</accordion-custom>';
        
        return utils.createElementFromHTML(faqItemHTML);
      }
    }

    // Initialize if container exists
    var container = document.querySelector(selectors.container);
    if (container) {
      initSearch();
    }
  }

  // Initialize FAQ Search when DOM is ready
  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        new FaqSearch();
      });
    } else {
      new FaqSearch();
    }
  }

  init();

})();